import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Dropdown,
  DropdownButton,
  Spinner,
} from "react-bootstrap";
import { getLatestCases } from "../../../../../services/ActionStatusApi";
import TopLimitDropdown from "../../../../../common/TopLimitDropdown";
import AccordionComponent from "../../../../../common/Accordion";
import { useDispatch } from "react-redux";
import {
  setClaimNumber,
  setIsDashboard,
  setNewCaseInFoID,
} from "../../../../../redux/slice/CaseHeaderSlice";

interface AllDashBoardsDetail {
  caseInfoId: number;
  patientName: string;
  caseInfoText: string | null;
  lastModifiedDate: string;
  caseinfo: any;
  customerAccountNo?: string;
}

interface LatestCaseProps {
  openDropdown: string | null;
  setOpenDropdown: React.Dispatch<React.SetStateAction<string | null>>;
  setShowRushNotesSummary: any;
}

const LatestCaseSummary: React.FC<LatestCaseProps> = ({
  openDropdown,
  setOpenDropdown,
  setShowRushNotesSummary,
}) => {
  const dispatch = useDispatch();
  const [limit, setLimit] = useState<number>(5);
  const [limitLabel, setLimitLabel] = useState<string>("Top 5");
  const [caseData, setCaseData] = useState<AllDashBoardsDetail[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [visibleHeaderIndex, setVisibleHeaderIndex] = useState<boolean>(false);

  const fetchLatestCases = async (limitValue: number) => {
    setLoading(true);
    try {
      const data = await getLatestCases(limitValue);
      setCaseData(data);
    } catch (error) {
      console.error("Failed to fetch latest cases:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLatestCases(limit);
  }, [limit]);

  const handleLimitChange = (value: number, label: string) => {
    setLimit(value);
    setLimitLabel(label);
  };

  const handleOpenRushNotes = (e: React.MouseEvent) => {
    e.stopPropagation();
    setLimit(5);
    setLimitLabel("Top 5");
    setShowRushNotesSummary(true);
    
  };

  const [LatestCaseKey, setLatestCaseKey] = useState<string | null>("0");

  const handleBodyAccordionSelect = (key: string | null) => {
    // Prevent collapsing if the same key is clicked
    if (LatestCaseKey === key) {
      return; // do nothing
    }
    setLatestCaseKey(key || "0");
  };

  const LatestCaseAccordion = (
    items: { title: JSX.Element; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={LatestCaseKey}
      onSelect={handleBodyAccordionSelect}
    />
  );

  return (
    <>
      {LatestCaseAccordion([
        {
          title: (
            <div
              className={`d-flex align-items-center w-100 ${
                caseData.length === 0 ? "onloadNOScroll" : ""
              }`}
            >
              <span className="me-auto">Latest Case</span>

              <div onClick={(e) => e.stopPropagation()}>
                <TopLimitDropdown
                  title={limitLabel}
                  onSelect={handleLimitChange}
                  show={openDropdown === "latest"}
                  onToggle={(isOpen) =>
                    setOpenDropdown(isOpen ? "latest" : null)
                  }
                />
              </div>
              <span className="rushIcon rushiconDashboard">
                {" "}
                <span
                  className="material-symbols-outlined me-2 rushicon   p-1 heartbeat"
                  onClick={handleOpenRushNotes}
                >
                  sprint
                </span>
              </span>
            </div>
          ),
          content: (
            <>
              <Card className="border-0 ">
                <Card.Body className="d-flex flex-column p-0 bg-theme">
                  <div
                    style={{
                      maxHeight: limit > 5 ? "50vh" : "auto",
                      overflowY: "auto",
                    }}
                    className="d-flex flex-column gap-1 flex-grow-1"
                  >
                    {caseData.length === 0 ? (
                      <p>No cases found.</p>
                    ) : (
                      caseData.map((item, index) => (
                        <div
                          key={index}
                          className="latest-case d-flex align-items-center slide-up-onload"
                        >
                          <div
                            className="d-flex flex-column text-truncate w-100 p-0"
                            style={{ width: "98%", lineHeight: "1.1" }}
                          >
                            <span>
                              {item.patientName}{" "}
                              {item.customerAccountNo &&
                                `(${item.customerAccountNo})`}
                            </span>
                            <a
                              href="#/search-case"
                              className="text-blue-600 underline dashbardCaseAnchr"
                              onClick={(e) => {
                                dispatch(setIsDashboard(true));
                                dispatch(setNewCaseInFoID(item.caseInfoId));
                                dispatch(setClaimNumber(item.caseinfo));
                                setVisibleHeaderIndex(true);
                              }}
                            >
                              {item.caseinfo || "-"}
                            </a>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </Card.Body>
              </Card>
            </>
          ),
        },
      ])}
    </>
  );
};

export default LatestCaseSummary;
